import React, { useState } from "react"
import { MdClose } from "react-icons/md"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import TdForm from "./TdForm"
import TdList from "./TdList"
import TdOptions from "./TdOptions"
import { Navbar } from "components"
import TdAutoGenerate from "./TdAutoGenerate"
import classes from "./index.module.scss"

const TdSidebar = props => {
  const {
    noTables,
    thisLevelTables,
    tables,
    setTables,
    setSelectedFloor,
    openTableSidebar,
    setOpenTableSidebar
  } = props

  const [t, i18n] = useTranslation()

  const history = useHistory()

  const [layout, setLayout] = useState("list")
  const [selectedTable, setSelectedTable] = useState(null)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      id="table-sidebar"
      className={clsx(
        classes["sidebar"],
        isLtr && classes["sidebar-ltr"],
        openTableSidebar && classes["open"],
        openTableSidebar && isLtr && classes["open-ltr"]
      )}
    >
      <Navbar
        variant="compact"
        onLeftIconPress={() => history.goBack()}
        title={t("تنظیمات_میز_ها")}
        rightSideComponent={() =>
          <button
            className={classes["close-button"]}
            onClick={() => setOpenTableSidebar(false)}
          >
            <MdClose size={20} />
          </button>
        }
      />
      {
        layout === "form" &&
        <TdForm
          tables={tables}
          setTables={setTables}
          setLayout={setLayout}
          selectedTable={selectedTable}
          setSelectedTable={setSelectedTable}
          setSelectedFloor={setSelectedFloor}
        />
      }
      {
        layout === "list" &&
        <TdList
          noTables={noTables}
          thisLevelTables={thisLevelTables}
          setTables={setTables}
          setLayout={setLayout}
          setSelectedTable={setSelectedTable}
        />
      }
      {
        layout === "options" &&
        <TdOptions
          setLayout={setLayout}
        />
      }
      {
        layout === "autoGenerate" &&
        <TdAutoGenerate
          setTables={setTables}
          setLayout={setLayout}
          setSelectedFloor={setSelectedFloor}
        />
      }
    </div>
  )
}

export default TdSidebar